import { Provider } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { IImpersonationContextComponentProps } from '../../../../models';
import { useAdminAccountQuery } from '../../../../queries';
import { ImpersonationContextViewModel } from '../../../../viewmodels/AdminViewModels';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { MultiEmailScheduler } from '../../../../web/containers/MultiCampaignScheduler/components/emails/MultiEmailScheduler';

export function AccountMultiEmailScheduler() {
	const params = useParams<{ accountId: string }>();
	const [impersonationProviderProps, setImpersonationProviderProps] =
		useState<IImpersonationContextComponentProps>(null);
	const adminAccountQuery = useAdminAccountQuery({
		accountId: params.accountId,
	});
	useEffect(() => {
		if (adminAccountQuery.data) {
			const impersonationContext = new ImpersonationContextViewModel({
				account: adminAccountQuery.data,
			});

			setImpersonationProviderProps({
				impersonationContext,
			});
		}
	}, [adminAccountQuery.data]);
	if (!impersonationProviderProps) {
		return <LoadingSpinner />;
	}
	return (
		<Provider impersonationContext={impersonationProviderProps.impersonationContext}>
			<MultiEmailScheduler impersonationContext={impersonationProviderProps.impersonationContext} />
		</Provider>
	);
}
